import { createFileRoute } from '@tanstack/react-router'
import { LoginForm } from '@/components/login-form'

export const Route = createFileRoute('/{-$locale}/login')({
  ssr: false,
  component: LoginPage,
})

function LoginPage() {
  return (
    <div className="account-frame">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  )
}
